// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"246":"landing","283":"buy","789":"sell"}[chunkId] || chunkId) + "." + {"104":"ff33231f","246":"a4b10831","283":"6e315a76","739":"c057007b","789":"b1b60888"}[chunkId] + ".css";
};